import { HeroSection } from '../components/sections/HeroSection';
import { ServicesOverview } from '../components/sections/ServicesOverview';
import { WhyChooseUs } from '../components/sections/WhyChooseUs';
import { PortfolioPreview } from '../components/sections/PortfolioPreview';
import { Testimonials } from '../components/sections/Testimonials';
import { ContactCTA } from '../components/sections/ContactCTA';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ServicesOverview />
      <WhyChooseUs />
      <PortfolioPreview />
      <Testimonials />
      <ContactCTA />
    </main>
  );
}
